<template>
    <div>
        <el-dialog
            title="添加户型"
            :visible.sync="showdialog"
            width="800px"
            v-dialogDrag
            @close="close">
            <el-form :model="form" ref="form" label-width="80px" :inline="false" size="mini">
                <el-form-item label="户型名称">
                    <div class="flex-box input-box">
                        <el-input class="input" v-model="form.name" placeholder="户型名称" clearable></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.type" placeholder="请选择" size="mini" :disabled="subStation">
                        <el-option :label="item" :value="item" v-for="(item, index) in types" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售状态">
                    <el-select v-model="form.sell" placeholder="请选择" size="mini">
                        <el-option :label="item" :value="item" v-for="(item, index) in sells" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="主推">
                    <el-switch v-model="form.popularize" :active-value="true" :inactive-value="false">
                    </el-switch>{{form.popularize?'是':'否'}}
                </el-form-item>
                <el-form-item label="面积">
                    <div class="flex-box input-box">
                        <el-input class="input" type="number" v-model="form.area[0]" placeholder="" clearable></el-input>
                        <span>-</span>
                        <el-input class="input" type="number" v-model="form.area[1]" placeholder="" clearable></el-input>㎡
                    </div>
                </el-form-item>
                <el-form-item label="价格">
                    <div class="flex-box input-box">
                        <el-input class="input" type="number" v-model="form.price" placeholder="" clearable></el-input>元
                    </div>
                </el-form-item>
                <el-form-item label="配置" v-if="this.form.type == '住宅'">
                    <el-form label-width="80px" :inline="false" size="mini">
                        <el-form-item label="室">
                            <el-input-number v-model="form.room" :min="0" :max="30" :step="1"></el-input-number>
                        </el-form-item>
                        <el-form-item label="厅">
                            <el-input-number v-model="form.drawing" :min="0" :max="30" :step="1"></el-input-number>
                        </el-form-item>
                        <el-form-item label="卫">
                            <el-input-number v-model="form.toilet" :min="0" :max="30" :step="1"></el-input-number>
                        </el-form-item>
                    </el-form>
                </el-form-item>
                <el-form-item label="户型图">
                    <el-upload
                        class="avatar-uploader"
                        action="/api/Upload/uploadFile/"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess">
                        <img v-if="form.thumbnail" :src="form.thumbnail" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="confirm">保存</el-button>
                    <el-button>取消</el-button>
                </el-form-item>
            </el-form>
            
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showdialog: true,
            id: '',
            form: {
                name: '',
                thumbnail: '',
                type: '',
                sell: '',
                popularize: false,
                area: [],
                price: '',
                room: 0,
                drawing: 0,
                toilet: 0,
            },
            types: ['住宅', '公寓', '商铺', '写字楼', '康旅', '厂房', '其他'],
            sells: ['在售', '待售', '售馨'],
            subStation:false,
        }
    },
    mounted () {
        this.id = this.$route.query.id;
        this.subStation = this.$route.query.subStation;
        if(this.subStation === 'true'){
            this.subStation = true;
            this.form.type = '康旅';
        } 
        else this.subStation = false;
    },
    methods: {
        close() {
            this.$router.go(-1);
        },
        confirm() {
            var params = {
                id: this.id,
                name: this.form.name,
                thumbnail: this.form.thumbnail,
                type: this.form.type,
                sell: this.form.sell,
                area: JSON.stringify(this.form.area),
                popularize: this.form.popularize,
                price: this.form.price,
                room: this.form.room,
                drawing: this.form.drawing,
                toilet: this.form.toilet,
            };
            this.$api.addProjectType(params).then(
                data=>{
                    this.$message.success(data);
                    this.$router.go(-1);
                }
            )
        },
        handleAvatarSuccess(e) {
            let {data, errCode, msg} = e;
            if (data){
                this.$message.success(msg);
                this.form.thumbnail = data;
            } else {
                this.$message.error(msg);
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.input-box{
    margin-right: 470px;
}
::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
::v-deep .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>